"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const AbstractInitializer_1 = __importDefault(require("../AbstractInitializer"));
const asyncIterate_1 = __importDefault(require("../../../../Util/asyncIterate"));
const getWeekDayTypeIterator_1 = __importDefault(require("../Maker/getWeekDayTypeIterator"));
class DayTypeInitializer extends AbstractInitializer_1.default {
    constructor(cache, dayTypeModel, customerRepository, dateTimeProvider, dateTimeModifier) {
        super("day_type_initializer", cache);
        this.initialize = async () => {
            const currentDate = this.dateTimeProvider.currentDate();
            const weekDayTypeIterator = (0, getWeekDayTypeIterator_1.default)();
            await (0, asyncIterate_1.default)(await this.customerRepository.getCustomers(), async (customer) => {
                const daysDiff = Math.abs(this.dateTimeModifier.daysDiff(customer.subscriptionPeriod.startDate, currentDate)) + 1;
                const dayTypes = {};
                for (let d = 0; d < daysDiff; d++) {
                    dayTypes[this.dateTimeModifier.modifyDays(customer.subscriptionPeriod.startDate, d)] = weekDayTypeIterator.next();
                }
                await this.dayTypeModel.setDayTypes(customer.id, dayTypes);
            });
        };
        this.dayTypeModel = dayTypeModel;
        this.customerRepository = customerRepository;
        this.dateTimeProvider = dateTimeProvider;
        this.dateTimeModifier = dateTimeModifier;
    }
}
exports.default = DayTypeInitializer;
//# sourceMappingURL=DayTypeInitializer.js.map